import { FormattedMessage } from 'react-intl';
import Spinner from '@/shared/components/Spinner';

interface Props {
  status: string;
}

export default function ScheduleStatusLabel({ status }: Props) {
  return (
    <span className="flex items-center gap-1.5">
      {status === 'active' && <Spinner className="h-3 w-3 shrink-0" />}
      <FormattedMessage id={`schedule.status.${status}`} />
    </span>
  );
}
